import angular from 'angular';
import component from './escalations.component';

const escalationsModule = angular
    .module('dt.components.organization-alert-config.escalations', [])
    .component('escalations', component);

export default escalationsModule.name;
